export default __webpack_public_path__ + "static/media/play_button_green.048e5e6f.png";